// extracted by mini-css-extract-plugin
module.exports = {"container":"_61cc05a7c9--container--3GKA0","title":"_61cc05a7c9--title--3Stal","description":"_61cc05a7c9--description--2MpCk"};